import { ButtonBase, Menu, styled } from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";
import { ChevronArrowDownIcon } from "components/Icons";

import { Typography } from "components/Typography";
import { useMenu } from "hooks/useMenu";

const MenuItem = styled(MuiMenuItem)(() => ({
  fontSize: "12px",
}));

export const STATUS_TYPES = {
  SUCCESS: 1,
  PENDING: 0,
  FAILED: -1,
};

const STATUS_OPTIONS = {
  [STATUS_TYPES.SUCCESS]: "Succesful",
  [STATUS_TYPES.PENDING]: "Pending",
  [STATUS_TYPES.FAILED]: "Failed",
};

export const StatusFilter = ({ onStatusChange, selectedStatus }) => {
  const { anchorEl, handleClose, handleOpen, open } = useMenu();

  const label = STATUS_OPTIONS[selectedStatus] || "All";

  const handleStatusSelect = (status) => {
    onStatusChange(status);
    handleClose();
  };

  return (
    <>
      <ButtonBase
        onClick={handleOpen}
        disableRipple
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "8px",
          border: "1px solid #EBEDEF",
          borderRadius: "8px",
          padding: "8px 15px",
        }}
      >
        <Typography variant="notification">{label}</Typography>
        <ChevronArrowDownIcon
          sx={{ color: "#8E95A4", fontSize: "14px", marginLeft: "5px" }}
        />
      </ButtonBase>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem key="all" onClick={() => handleStatusSelect("")}>
          All
        </MenuItem>
        {Object.entries(STATUS_OPTIONS).map(([value, label]) => (
          <MenuItem key={value} onClick={() => handleStatusSelect(value)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
